module.exports = __webpack_public_path__ + "static/media/logo-white.f0ce32c2.png";